type VersionReloadDialogProps = {
  currentVersion: string
  latestVersion: string
  onReload?: () => void
}

export function VersionReloadDialog({
  currentVersion,
  latestVersion,
  onReload,
}: VersionReloadDialogProps) {
  const handleReload = () => {
    if (onReload) {
      onReload()
      return
    }
    window.location.reload()
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: 16,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 480,
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 12px 32px rgba(0, 0, 0, 0.18)',
          padding: 24,
        }}
      >
        <h2 style={{ margin: '0 0 12px', fontSize: 22 }}>新しいバージョンがあります</h2>
        <p style={{ margin: '0 0 8px', lineHeight: 1.6 }}>
          安全に利用するため、画面を再読み込みしてください。
        </p>
        <p style={{ margin: '0 0 20px', color: '#555', lineHeight: 1.6 }}>
          現在のバージョン: {currentVersion}
          <br />
          最新のバージョン: {latestVersion}
        </p>
        <button
          type="button"
          onClick={handleReload}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 140,
            border: 0,
            borderRadius: 8,
            backgroundColor: '#0d6efd',
            color: '#fff',
            padding: '10px 18px',
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: 600,
          }}
        >
          再読み込み
        </button>
      </div>
    </div>
  )
}
